/**
 * Component to filter organization lists
 */
import * as React from 'react';
import { Card, Row, Col, Input } from 'antd';
import '../../css/OrganizationFilter.scss';
import strings from '../../eyeguide-localization/customer/string.customer.filter';
// import service from '../../service/apolloclient.service';

interface IFilterProps {
    notifyChangeFilter: any; 
    filterObj: any;
}
    
interface IFilterState {
    sportsArr: any;
    orgs: any;
    isOpen: boolean;
    showOrg: boolean;
    showNotifs: boolean;
    filterObj: any;
}

export default class CustomerFilter extends React.Component<IFilterProps, IFilterState> {
    name: any;
    constructor(props: IFilterProps) {
        super(props); 
        this.name = '';
        this.state = {
            sportsArr: [],
            orgs: [],
            isOpen: false,
            showOrg: false,
            showNotifs: false,
            filterObj: {
                'name' : '',
                'contactfirstname'  : '',
                'contactlastname'  : '',
                'contactphone' : '',
                'contactemail' : ''
            }
        };
    }

    async componentDidMount() {
        strings.setLanguage(navigator.language);
        // let ser = new service();
        // let res: any = await ser.getOrganizations();
        this.setState({
            // orgs: res,
             filterObj: this.props.filterObj
        });
        setTimeout(() => {this.name.focus() ; }, 1);
        
    }

    componentWillReceiveProps(nextProps: any) {
        console.log('next props',  nextProps.filterObj);
        this.setState({
            isOpen: nextProps.isOpen,
            showOrg: nextProps.showOrg,
            showNotifs: nextProps.showNotifs,
            filterObj: nextProps.filterObj
        });
    }

    render() {
        return(
            <div className="OrganizationFilter">
                <Card className="filterCard" bordered={false} style={{ margin: '24px 16px' }}>
                    <Row className="row">
                        <Col xs={8} sm={8} md={5} lg={6} xl={5} className="labelFrame">
                            <div className="label">
                                <span> {strings.lsNameTxt}
                                :</span>
                            </div>
                        </Col>
                        <Col xs={14} sm={14} md={16} lg={10} xl={11}>
                            <Input 
                                ref={val => this.name = val}
                                defaultValue=""
                                placeholder="e.g. High School USA" 
                                onChange={(val) => this.handleChange(val.target.value, 'name')}
                                value={this.state.filterObj.name}
                                autoFocus={true}
                            />
                        </Col>                  
                    </Row>
                    <Row className="row" />
                    {/* <Row className="row">
                        <Col xs={1} sm={1} md={2} lg={4} xl={4} />
                        <Col xs={8} sm={8} md={5} lg={6} xl={5} className="labelFrame">
                            <div className="label">
                                <span>   {strings.lsContactFirstNameTxt} 
                                :</span>
                            </div>
                        </Col>
                        <Col xs={14} sm={14} md={16} lg={10} xl={11}>
                            <Input 
                                placeholder="e.g. Johnny"
                                onChange={(val) => this.handleChange(val.target.value, 'contactfirstname')}
                                value={this.state.filterObj.contactfirstname}
                            />
                        </Col>
                        <Col xs={1} sm={1} md={2} lg={6} xl={4}/>
                    </Row>
                    <Row className="row">
                        <Col xs={1} sm={1} md={2} lg={4} xl={4} />
                        <Col xs={8} sm={8} md={5} lg={6} xl={5} className="labelFrame">
                            <div className="label">
                                <span>   {strings.lsContactLastNameTxt} 
                                :</span>
                            </div>
                        </Col>
                        <Col xs={14} sm={14} md={16} lg={10} xl={11}>
                            <Input 
                                placeholder="e.g. Thomas"
                                onChange={(val) => this.handleChange(val.target.value, 'contactlastname')}
                                value={this.state.filterObj.contactlastname}
                            />
                        </Col>
                        <Col xs={1} sm={1} md={2} lg={6} xl={4}/>
                    </Row>
                    <Row className="row">
                        <Col xs={1} sm={1} md={2} lg={4} xl={4} />
                        <Col xs={8} sm={8} md={5} lg={6} xl={5} className="labelFrame">
                        <div className="label">{strings.lsContactPhoneTxt} :</div></Col>
                        <Col xs={14} sm={14} md={16} lg={10} xl={11}>
                        <Input 
                            placeholder="e.g. 123-456-7890" 
                            onChange={(val) => {console.log('inputchanged', val.target.value);
                                                this.handleChange(val.target.value, 'contactphone'); }}
                            value={this.state.filterObj.contactphone}
                        />
                        </Col>
                        <Col xs={1} sm={1} md={2} lg={6} xl={4}/>
                    </Row>
                    <Row className="row">
                        <Col xs={1} sm={1} md={2} lg={4} xl={4} />
                        <Col xs={8} sm={8} md={5} lg={6} xl={5} className="labelFrame">
                        <div className="label">{strings.lsContactEmailTxt} :</div></Col>
                        <Col xs={14} sm={14} md={16} lg={10} xl={11}>
                        <Input 
                            placeholder="e.g. johny.thomas@school.edu" 
                            onChange={(val) => {console.log('inputchanged', val.target.value);
                                                this.handleChange(val.target.value, 'contactemail'); }}
                            value={this.state.filterObj.contactemail}
                        />
                        </Col>
                        <Col xs={1} sm={1} md={2} lg={6} xl={4}/>
                    </Row> */}
                </Card>
            </div>
        );
    }

    private handleChange(e: any, prop: string) {
        console.log('handleChange', e);
        if (!(e instanceof Array) && e.toString().trim().length === 0) {
            e = '';
        }
        let filterObj = this.state.filterObj;
        filterObj[prop] = e;
        this.setState({
            filterObj: filterObj
        });
        console.log('this.state.filterObj', this.state.filterObj);
        this.props.notifyChangeFilter(this.state.filterObj);
    }

}


// WEBPACK FOOTER //
// ./src/components/customer/CustomerFilter.tsx